
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"49","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.717 25.286v3.938h-.971v-3.938H13.02v-.909h3.726v-3.938h.97v3.938h3.726v.91h-3.725zm5.762-1.415v-.91h8.422v.91H23.48zm0 2.837v-.91h8.422v.91H23.48z","fill":"currentColor"}})])
          )
        }
      }
    